"use strict";
var $ = require("jquery");
var RichContentUtils = (function () {
    function RichContentUtils() {
    }
    RichContentUtils.getRelativeUrl = function (absoluteUrl) {
        if (absoluteUrl.indexOf('http://' + location.host) != 0
            && absoluteUrl.indexOf('https://' + location.host) != 0
            && absoluteUrl.indexOf('//' + location.host) != 0) {
            return absoluteUrl;
        }
        return absoluteUrl.substring(absoluteUrl.indexOf('//') + 2 + location.host.length);
    };
    RichContentUtils.replaceEmoji = function (html) {
        var _this = this;
        try {
            var $div = $("<div/>").html(html);
            $div.find("img.emojione").each(function (i, el) {
                var $el = $(el), src = _this.getRelativeUrl($el.attr("src")), alt = $el.attr("alt");
                var $span = $("<span/>", {
                    "class": "emojione fr-emoticon fr-deletable fr-emoticon-img",
                    "data-emoji": alt,
                    "style": "background-image: url(" + src + ")",
                    html: "&nbsp;"
                });
                html = html.replace(el.outerHTML, $span[0].outerHTML);
            });
        }
        catch (ex) {
            console.error(ex);
        }
        return html;
    };
    RichContentUtils.richTextToFroala = function (html) {
        try {
            html = this.replaceEmoji(html);
            var $div = $("<div/>").html(html);
            $div.find(".spoiler").each(function (i, el) {
                var $el = $(el), title = $el.find(".spoiler-title").first().text(), content = $el.find(".spoiler-content").first().html();
                var spoilerHtml = ("<p>[spoiler=" + title + "]</p>") + content + "<p>[/spoiler]</p>";
                html = html.replace(el.outerHTML, spoilerHtml);
            });
        }
        catch (ex) {
            console.error(ex);
        }
        return html;
    };
    RichContentUtils.htmlToPlainText = function (html) {
        var returnText = "" + html;
        //-- remove BR tags and replace them with line break
        returnText = returnText.replace(/<br>/gi, "\n");
        returnText = returnText.replace(/<br\s\/>/gi, "\n");
        returnText = returnText.replace(/<br\/>/gi, "\n");
        //-- remove P and A tags but preserve what's inside of them
        returnText = returnText.replace(/<p.*?>/gi, "\n");
        returnText = returnText.replace(/<a.*href="(.*?)".*>(.*?)<\/a>/gi, "$1");
        //-- remove all else
        returnText = returnText.replace(/<(?:.|\s)*?>/g, "");
        //-- get rid of more than 2 multiple line breaks:
        returnText = returnText.replace(/(?:(?:\r\n|\r|\n)\s*){2,}/gim, "\n\n");
        //-- get rid of more than 2 spaces:
        returnText = returnText.replace(/ +(?= )/g, '');
        //-- get rid of html-encoded characters:
        returnText = returnText.replace(/&nbsp;/gi, " ");
        returnText = returnText.replace(/&amp;/gi, "&");
        returnText = returnText.replace(/&quot;/gi, '"');
        returnText = returnText.replace(/&lt;/gi, '<');
        returnText = returnText.replace(/&gt;/gi, '>');
        return returnText.trim();
    };
    RichContentUtils.processHtml = function (html, linkify) {
        if (linkify === void 0) { linkify = true; }
    };
    return RichContentUtils;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RichContentUtils;
//# sourceMappingURL=richContentUtils.js.map